module.exports = __webpack_public_path__ + "img/header-admin.549057ca.png";